import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  InputAdornment,
    FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik } from "formik";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

//Services
import CorporateApi from "Services/CorporateEmployee";

//DropZone
// import DropZone from "./DropZone";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EmployeeCreate = (props) => {
  const { openDialog, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [groups , setGroups] = useState([]);
    const  corporateId = useSelector(
      (state) => state?.ProfileSettingsReducer?.profiledetails?._id
    );

// get the group details    

  // Get Passenger list api
  const getCorporategrps = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
       // console.log('datas ---> ',res?.data?.data?.data);
        setGroups(res?.data?.data?.data);
      } else {
        setGroups([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    CorporateApi
      .getCorporategrpList({ page:1, limit: "unlimited", search: ""})
      .then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    getCorporategrps();
  }, [getCorporategrps]);

  //pagination
  const handleAddEmployee = (formValues) => {
 dispatch(showLoader("Loading please wait..."));

    let validatationPass = true;

    const data = {
      corporateGroupName: formValues?.corporateGroupName,
      corporateId:corporateId,
      groupId:formValues?.groupId,
      employeeName:formValues?.employeeName,
      employeeEmail:formValues?.employeeEmail,
      employeeGender:formValues?.employeeGender,
      employeeCode:formValues?.employeeCode,
      employeeMobile:formValues?.employeeMobile,
      employeeBaselocation:formValues?.employeeBaselocation,
    };
    
  // console.log('data--->',data);

   // return false;
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Employee Created Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik.resetForm();
        handleClose();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while create Employee",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };

    if (validatationPass) {
      CorporateApi.addCorporateEmployee({ ...data }).then(onSuccess, onFailure);
    }
  };

  // Formik
  const formik = useFormik({
    initialValues: {
      corporateGroupName: "",
      groupId:"",
      employeeName:"",
      employeeEmail:"",
      employeeGender:"",
      employeeCode:"",
      employeeMobile:"",
      employeeBaselocation:"",
    },
    validationSchema: yup.object({
      corporateGroupName: yup.string().required("Group Name is required").nullable(),
      employeeName: yup.string().required("Employee Name is required").nullable(),
      employeeEmail: yup.string().required("Employee Email is required").nullable(),
      employeeGender: yup.string().required("Employee Gender is required").nullable(),
      employeeCode: yup.string().required("Employee Code is required").nullable(),
      employeeMobile: yup.string().required("Employee mobile is required").nullable(),
      employeeBaselocation: yup.string().required("Employee base location is required").nullable(),
    }),
    enableReinitialize: true,
    onSubmit: handleAddEmployee,
  });

  //Tabs

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Add Employee
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>

          <Grid container>

          <Grid container>
            <section className={classes.container}>
              <Grid item xs={12} className={classes.detailsContainer}>
                <Grid container className={classes.containerWrapper}>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid container>
{/*employeeName*/}
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          id="employeeName"
                          label="Employee Name"
                          value={formik?.values?.employeeName}
                          defaultValue={formik?.values?.employeeName}
                          onChange={formik.handleChange}
                          error={
                            formik?.errors?.employeeName &&
                            formik?.touched?.employeeName
                          }
                          helperText={
                            formik?.errors?.employeeName &&
                            formik?.touched?.employeeName &&
                            formik?.errors?.employeeName
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        ></TextField>
                      </Grid>
{/*employeeEmail*/}
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          id="employeeEmail"
                          label="Employee Email"
                          value={formik?.values?.employeeEmail}
                          defaultValue={formik?.values?.employeeEmail}
                          onChange={formik.handleChange}
                          error={
                            formik?.errors?.employeeEmail &&
                            formik?.touched?.employeeEmail
                          }
                          helperText={
                            formik?.errors?.employeeEmail &&
                            formik?.touched?.employeeEmail &&
                            formik?.errors?.employeeEmail
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        ></TextField>
                      </Grid>
{/*corporateGroupName*/}                      
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
<TextField
  name="corporateGroupName"
  id="corporateGroupName"
  label="Group Name"
  value={formik?.values?.corporateGroupName}
  onChange={(e) => {
    const selectedGroupName = e.target.value;
    const selectedGroup = groups.find(
      (group) => group.corporateGroupName === selectedGroupName
    );

    formik.setFieldValue("corporateGroupName", selectedGroupName);
    formik.setFieldValue("groupId", selectedGroup?._id || "");
  }}
  select
  error={formik?.touched?.corporateGroupName && Boolean(formik?.errors?.corporateGroupName)}
  helperText={
    formik?.touched?.corporateGroupName && formik?.errors?.corporateGroupName
  }
  fullWidth
  variant="outlined"
  size="small"
>
  {groups.map((group) => (
    <MenuItem key={group._id} value={group.corporateGroupName}>
      {group.corporateGroupName}
    </MenuItem>
  ))}
</TextField>
                      </Grid>
{/*employeeGender*/}                      
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                        name="employeeGender"
                        id="employeeGender"
                        label="Employee Gender"
                        value={formik?.values?.employeeGender}
                        defaultValue={formik?.values?.employeeGender}
                        onChange={formik.handleChange}
                        select
                        error={
                        formik?.errors?.employeeGender &&
                        formik?.touched?.employeeGender
                        }
                        helperText={
                        formik?.errors?.employeeGender &&
                        formik?.touched?.employeeGender &&
                        formik?.errors?.employeeGender
                        }
                        fullWidth
                        variant="outlined"
                        size="small"
                        >
                        <MenuItem value="Male">Male</MenuItem>
                        <MenuItem value="Female">Female</MenuItem>       
                        </TextField>
                      </Grid>
{/*employeeCode*/}                      
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          id="employeeCode"
                          label="Employee Code"
                          value={formik?.values?.employeeCode}
                          defaultValue={formik?.values?.employeeCode}
                          onChange={formik.handleChange}
                          error={
                            formik?.errors?.employeeCode &&
                            formik?.touched?.employeeCode
                          }
                          helperText={
                            formik?.errors?.employeeCode &&
                            formik?.touched?.employeeCode &&
                            formik?.errors?.employeeCode
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        ></TextField>
                      </Grid>
{/*employeeMobile*/}                      
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          id="employeeMobile"
                          label="Employee Mobile Number"
                          value={formik?.values?.employeeMobile}
                          defaultValue={formik?.values?.employeeMobile}
                          onChange={formik.handleChange}
                          error={
                            formik?.errors?.employeeMobile &&
                            formik?.touched?.employeeMobile
                          }
                          helperText={
                            formik?.errors?.employeeMobile &&
                            formik?.touched?.employeeMobile &&
                            formik?.errors?.employeeMobile
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        ></TextField>
                      </Grid>         
{/*employeeBaselocation*/}                      
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
                          id="employeeBaselocation"
                          label="Employee Base Location"
                          value={formik?.values?.employeeBaselocation}
                          defaultValue={formik?.values?.employeeBaselocation}
                          onChange={formik.handleChange}
                          error={
                            formik?.errors?.employeeBaselocation &&
                            formik?.touched?.employeeBaselocation
                          }
                          helperText={
                            formik?.errors?.employeeBaselocation &&
                            formik?.touched?.employeeBaselocation &&
                            formik?.errors?.employeeBaselocation
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        ></TextField>
                      </Grid>                                        
</Grid>
</Grid>
</Grid>
</Grid>

       </section>
                </Grid>

                <Grid container>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={classes.sbtBtnWrapper}
                  >
                    <Button variant="contained" onClick={formik?.handleSubmit}>
                      Add Employee
                    </Button>
                  </Grid>
                </Grid>

              </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose}>Close</Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EmployeeCreate;
